export default {
      id: "ascending-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#ascending-usage",
      toString: function () {
        return this.url;
      }
    }